import { all, takeLatest, put } from "redux-saga/effects";
import { Actions } from "@grandvisionhq/configurator";
import "../../../state/actions.js";
import { resetSelectedPackage, resetSelectedAddOn } from "../../../configurations/state/configurations/actions.js";
const getStepChangeSagas = (id) => [
  takeLatest(resetSelectedPackage.type, function* () {
    const step = "lensPackage";
    yield put(Actions.resetStepVisited({ id, step }));
  }),
  takeLatest(
    resetSelectedAddOn.type,
    function* ({ payload }) {
      if (payload.reason !== "user selection") {
        const step = "lensAddOn";
        yield put(Actions.resetStepVisited({ id, step }));
      }
    }
  )
];
function* listenForStepChanges(id) {
  yield all(getStepChangeSagas(id));
}
export {
  getStepChangeSagas,
  listenForStepChanges
};
//# sourceMappingURL=sagas.js.map
